
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
export default BaseCmsBlock.extend({
  name: "GeographyCargoTransportationSimpleBlock",

  components: {
    Map: () => import("./components/GeographyCargoTransportationBlock/Map"),
  },
})
